import type { EstimationItemResponse } from '@/api/schema/data-contracts';
import type { ModalStatelessProps } from '@/components/ModalStateless';
import { ModalStateless } from '@/components/ModalStateless';
import { useMessages } from '@/hooks/messages';

import type { AssumptionsContainerProps } from './AssumptionsContainer';
import { AssumptionsContainer } from './AssumptionsContainer';
import { assumptionsMessageDefinitions } from './messages';

type AssumptionsModalProps = Omit<ModalStatelessProps, 'title' | 'open'> &
  Omit<AssumptionsContainerProps, 'estimationItemId'> & {
    estimationItem?: EstimationItemResponse;
  };

/**
 * Lists and updates assumptions linked to estimation items
 * @param estimationItem if not set it handles items of whole estimation
 * @returns
 */
export const AssumptionsModal: React.FC<AssumptionsModalProps> = ({
  estimationId,
  estimationItem,
  onClose,
  isReadOnlyForced,
}) => {
  const messages = useMessages(assumptionsMessageDefinitions);
  return (
    <ModalStateless
      title={messages.listModalTitleWithPhaseNameFormatted({
        phaseName: estimationItem?.name ?? '',
      })}
      open={!!estimationItem?.id}
      onClose={onClose}
    >
      {estimationItem && (
        <AssumptionsContainer
          estimationId={estimationId}
          estimationItemId={estimationItem?.id}
          isReadOnlyForced={isReadOnlyForced}
        />
      )}
    </ModalStateless>
  );
};
